import React from 'react';

import { Results, SearchBox, WithSearch } from '@elastic/react-search-ui';
import { Layout as SearchLayout } from '@elastic/react-search-ui-views';
import Layout from '../components/layout';
import styled from 'styled-components';
import { Col, Row } from 'antd';

import '@elastic/react-search-ui-views/lib/styles/styles.css';
import SEO from '../components/seo';
import { Title } from '../components/styles';

const SearchInput = styled.div`
  width: 100%;
  margin: 16px 0 32px;
`;

const SearchResults = styled.div`
  margin-bottom: 32px;
`;

const SearchItem = styled.div`
  padding: 12px 16px;
  border-radius: 8px;

  &:hover {
    background-color: #99999920;
  }

  a {
    color: #333;
  }
  strong {
    font-size: 18px;
  }
  .search-body {
    color: #999;
    font-size: 14px;
    line-height: 1.2;
    margin-top: 8px;
  }
  em {
    background-color: #1a336320;
    color: #000;
    padding: 4px 6px;
    border-radius: 4px;
  }
`;

export default function App() {
  return (
    <Layout>
      <SEO
        title="AAA Search"
        description="Search AAA Sites"
        canonicalUrl="/search"
      />

      <Row style={{ marginTop: 32 }}>
        <Col xs={{ span: 22, offset: 1 }} md={{ span: 20, offset: 2 }}>
          <Title>Search AAA</Title>

          <SearchInput>
            <SearchBox
              autocompleteResults={{
                titleField: 'title',
                urlField: 'url',
              }}
              autocompleteSuggestions={true}
            />
          </SearchInput>

          <SearchResults>
            <WithSearch
              mapContextToProps={(context) => ({
                ...context,
              })}
            >
              {({ results }) => {
                return (
                  <div>
                    {results.map((r) => (
                      <SearchItem key={r.id.raw}>
                        <a href={r.url.raw}>
                          <strong>{r.title.raw}</strong>
                          {/* <div
                            className="search-body"
                            dangerouslySetInnerHTML={{
                              __html: r.description.raw,
                            }}
                          /> */}
                          <div className="search-body">
                            {r.description ? `${r.description.raw}...` : null}
                          </div>
                        </a>
                      </SearchItem>
                    ))}
                  </div>
                );
              }}
            </WithSearch>
          </SearchResults>
        </Col>
      </Row>
    </Layout>
  );
}
